import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeaturesBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { primaryBlockDefaultStyles } from "../constants";
import { HomepageBlock4_2 as Block } from "./HomepageBlock4_2";
import { defaultData } from "./HomepageBlock4_2DefaultData";
import imagePreview from "./homepage_block_4_2_preview.png";

export const HomepageBlock4_2: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Homepage Block 4 2",
    nameI18n: "builder_ui.block_type.homepage.block_4_2",
    version: 1,
    category: [FeaturesBlock],
    props: {
      header: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: primaryBlockDefaultStyles.backgroundColor,
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: primaryBlockDefaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: primaryBlockDefaultStyles.margin,
          },
        },
        type: "styles",
      },
    },
  },
};
